"use client"

import type React from "react"
import { useCallback, useRef, useState } from "react"
import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"
import { Progress } from "@/components/ui/progress"
import { AlertCircle, CheckCircle, ImageIcon, Upload, X } from "lucide-react"
import { cn } from "@/lib/utils"
//
// interface ImageUploadPropstest {
//   value?: string | File;
//   onChange: (value: string | File | undefined) => void;
//   onRemove?: () => void;
//   disabled?: boolean;
//   className?: string;
//   label?: string;
//   description?: string;
//   firebaseUploadFn?: (file: File) => Promise<string>; // Optional custom upload
//   // function
// }
//
// export function ImageUpload({
//   value,
//   onChange,
//   onRemove,
//   disabled = false,
//   className,
//   label = "Upload Image",
//   description = "Drag and drop an image or click to browse",
//   firebaseUploadFn,
// }: ImageUploadPropstest) {
//   const [isDragging, setIsDragging] = useState(false);
//   const [isUploading, setIsUploading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [error, setError] = useState<string | null>(null);
//   const fileInputRef = useRef<HTMLInputElement>(null);
//
//   const acceptedFormats = [
//     "image/jpeg",
//     "image/jpg",
//     "image/png",
//     "image/webp",
//     "image/gif",
//   ];
//   const maxFileSize = 5 * 1024 * 1024; // 5MB
//
//   const validateFile = (file: File): string | null => {
//     if (!acceptedFormats.includes(file.type)) {
//       return "Please upload a valid image file (JPEG, PNG, WebP, or GIF)";
//     }
//     if (file.size > maxFileSize) {
//       return "File size must be less than 5MB";
//     }
//     return null;
//   };
//
//   const simulateUpload = (file: File): Promise<string> => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onload = () => {
//         // Simulate upload progress
//         let progress = 0;
//         const interval = setInterval(() => {
//           progress += Math.random() * 30;
//           if (progress >= 100) {
//             progress = 100;
//             clearInterval(interval);
//             setUploadProgress(100);
//             setTimeout(() => {
//               resolve(reader.result as string);
//             }, 500);
//           } else {
//             setUploadProgress(progress);
//           }
//         }, 200);
//       };
//       reader.onerror = () => reject(new Error("Failed to read file"));
//       reader.readAsDataURL(file);
//     });
//   };
//
//   const uploadToFirebase = async (file: File): Promise<string> => {
//     if (firebaseUploadFn) {
//       return firebaseUploadFn(file);
//     }
//     // Default: throw error if not provided
//     throw new Error("No Firebase upload function provided.");
//   };
//
//   const handleFileUpload = useCallback(
//     async (file: File) => {
//       setError(null);
//       const validationError = validateFile(file);
//
//       if (validationError) {
//         setError(validationError);
//         return;
//       }
//
//       setIsUploading(true);
//       setUploadProgress(0);
//
//       try {
//         let imageUrl: string;
//         if (firebaseUploadFn) {
//           // Use provided Firebase upload function
//           imageUrl = await uploadToFirebase(file);
//         } else {
//           // Fallback to simulate upload (for dev/testing)
//           imageUrl = await simulateUpload(file);
//         }
//         onChange(imageUrl);
//       } catch (err) {
//         setError("Failed to upload image. Please try again.");
//       } finally {
//         setIsUploading(false);
//         setUploadProgress(0);
//       }
//     },
//     [onChange, firebaseUploadFn],
//   );
//
//   const handleDrop = useCallback(
//     (e: React.DragEvent) => {
//       e.preventDefault();
//       setIsDragging(false);
//
//       if (disabled || isUploading) return;
//
//       const files = Array.from(e.dataTransfer.files);
//       if (files.length > 0) {
//         handleFileUpload(files[0]);
//       }
//     },
//     [disabled, isUploading, handleFileUpload],
//   );
//
//   const handleDragOver = useCallback(
//     (e: React.DragEvent) => {
//       e.preventDefault();
//       if (!disabled && !isUploading) {
//         setIsDragging(true);
//       }
//     },
//     [disabled, isUploading],
//   );
//
//   const handleDragLeave = useCallback((e: React.DragEvent) => {
//     e.preventDefault();
//     setIsDragging(false);
//   }, []);
//
//   // Helper to get preview URL
//   const getPreviewUrl = (val?: string | File) => {
//     if (!val) return undefined;
//     if (typeof val === "string") return val;
//     if (val instanceof File) return URL.createObjectURL(val);
//     return undefined;
//   };
//
//   const handleFileSelect = useCallback(
//     (e: React.ChangeEvent<HTMLInputElement>) => {
//       const files = e.target.files;
//       if (files && files.length > 0) {
//         onChange(files[0]);
//       }
//     },
//     [onChange],
//   );
//
//   const handleRemove = useCallback(() => {
//     if (onRemove) {
//       onRemove();
//     } else {
//       onChange(undefined);
//     }
//     setError(null);
//     if (fileInputRef.current) {
//       fileInputRef.current.value = "";
//     }
//   }, [onChange, onRemove]);
//
//   const openFileDialog = () => {
//     if (!disabled && !isUploading) {
//       fileInputRef.current?.click();
//     }
//   };
//
//   if (value && !isUploading) {
//     const previewUrl = getPreviewUrl(value);
//     return (
//       <Card className={cn("relative overflow-hidden", className)}>
//         <div className="aspect-video relative">
//           <img
//             src={previewUrl || "/placeholder.svg"}
//             alt="Uploaded image"
//             className="w-full h-full object-cover"
//             onError={(e) => {
//               (e.target as HTMLImageElement).src =
//                 "/placeholder.svg?height=200&width=300";
//             }}
//           />
//           <div className="absolute inset-0 bg-black/50 opacity-0
// hover:opacity-100 transition-opacity flex items-center justify-center"> <Button
// type="button" variant="destructive" size="sm" onClick={handleRemove}
// disabled={disabled} className="flex items-center gap-2" > <X className="h-4 w-4"
// /> Remove </Button> </div> <div className="absolute top-2 right-2"> <CheckCircle
// className="h-5 w-5 text-green-500 bg-white rounded-full" /> </div> </div> </Card>
// ); }  return ( <div className={cn("space-y-2", className)}> <Card className={cn(
// "border-2 border-dashed transition-colors cursor-pointer", isDragging &&
// "border-primary bg-primary/5", error && "border-destructive", disabled &&
// "opacity-50 cursor-not-allowed", )} onDrop={handleDrop}
// onDragOver={handleDragOver} onDragLeave={handleDragLeave}
// onClick={openFileDialog} > <div className="p-6 text-center space-y-4">
// {isUploading ? ( <div className="space-y-4"> <div className="flex items-center
// justify-center"> <Upload className="h-8 w-8 text-primary animate-pulse" /> </div>
// <div className="space-y-2"> <p className="text-sm font-medium">Uploading
// image...</p> <Progress value={uploadProgress} className="w-full" /> <p
// className="text-xs text-muted-foreground"> {Math.round(uploadProgress)}% complete
// </p> </div> </div> ) : ( <div className="space-y-4"> <div className="flex
// items-center justify-center"> <ImageIcon className="h-8 w-8
// text-muted-foreground" /> </div> <div className="space-y-2"> <p
// className="text-sm font-medium">{label}</p> <p className="text-xs
// text-muted-foreground">{description}</p> <p className="text-xs
// text-muted-foreground"> Supports: JPEG, PNG, WebP, GIF (max 5MB) </p> </div>
// <Button type="button" variant="outline" size="sm" disabled={disabled} > <Upload
// className="h-4 w-4 mr-2" /> Choose File </Button> </div> )} </div> </Card>
// {error && ( <div className="flex items-center gap-2 text-sm text-destructive">
// <AlertCircle className="h-4 w-4" /> {error} </div> )}  <input ref={fileInputRef}
// type="file" accept={acceptedFormats.join(",")} onChange={handleFileSelect}
// className="hidden" disabled={disabled || isUploading} /> </div> ); }
;("use client")

interface ImageUploadProps {
	value?: string | File
	onChange: (value: string | File | undefined) => void
	onRemove?: () => void
	disabled?: boolean
	className?: string
	label?: string
	description?: string
}

export function ImageUpload({
	value,
	onChange,
	onRemove,
	disabled = false,
	className,
	label = "Upload Image",
	description = "Drag and drop an image or click to browse",
}: ImageUploadProps) {
	const [isDragging, setIsDragging] = useState(false)
	const [isUploading, setIsUploading] = useState(false)
	const [uploadProgress, setUploadProgress] = useState(0)
	const [error, setError] = useState<string | null>(null)
	const fileInputRef = useRef<HTMLInputElement>(null)

	const acceptedFormats = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/gif"]
	const maxFileSize = 5 * 1024 * 1024 // 5MB

	const validateFile = (file: File): string | null => {
		if (!acceptedFormats.includes(file.type)) {
			return "Please upload a valid image file (JPEG, PNG, WebP, or GIF)"
		}
		if (file.size > maxFileSize) {
			return "File size must be less than 5MB"
		}
		return null
	}

	const getPreviewUrl = (val?: string | File) => {
		if (!val) return undefined
		if (typeof val === "string") return val
		if (val instanceof File) return URL.createObjectURL(val)
		return undefined
	}
	// const simulateUpload = (file: File): Promise<string> => {
	// 	return new Promise((resolve, reject) => {
	// 		const reader = new FileReader()
	// 		reader.onload = () => {
	// 			// Simulate upload progress
	// 			let progress = 0
	// 			const interval = setInterval(() => {
	// 				progress += Math.random() * 30
	// 				if (progress >= 100) {
	// 					progress = 100
	// 					clearInterval(interval)
	// 					setUploadProgress(100)
	// 					setTimeout(() => {
	// 						resolve(reader.result as string)
	// 					}, 500)
	// 				} else {
	// 					setUploadProgress(progress)
	// 				}
	// 			}, 200)
	// 		}
	// 		reader.onerror = () => reject(new Error("Failed to read file"))
	// 		reader.readAsDataURL(file)
	// 	})
	// }

	const handleFileUpload = useCallback(
		async (file: File) => {
			setError(null)
			const validationError = validateFile(file)

			if (validationError) {
				setError(validationError)
				return
			}

			setIsUploading(true)
			setUploadProgress(0)

			try {
				// const imageUrl = await simulateUpload(file)
				onChange(file)
			} catch (err) {
				setError("Failed to upload image. Please try again.")
			} finally {
				setIsUploading(false)
				setUploadProgress(0)
			}
		},
		[onChange]
	)

	const handleDrop = useCallback(
		(e: React.DragEvent) => {
			e.preventDefault()
			setIsDragging(false)

			if (disabled || isUploading) return

			const files = Array.from(e.dataTransfer.files)
			if (files.length > 0) {
				handleFileUpload(files[0])
			}
		},
		[disabled, isUploading, handleFileUpload]
	)

	const handleDragOver = useCallback(
		(e: React.DragEvent) => {
			e.preventDefault()
			if (!disabled && !isUploading) {
				setIsDragging(true)
			}
		},
		[disabled, isUploading]
	)

	const handleDragLeave = useCallback((e: React.DragEvent) => {
		e.preventDefault()
		setIsDragging(false)
	}, [])

	// const handleFileSelect = useCallback(
	//   (e: React.ChangeEvent<HTMLInputElement>) => {
	//     const files = e.target.files;
	//     if (files && files.length > 0) {
	//       handleFileUpload(files[0]);
	//     }
	//   },
	//   [handleFileUpload],
	// );

	const handleFileSelect = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const files = e.target.files
			if (files && files.length > 0) {
				onChange(files[0]) // <-- Pass the File, not a string
			}
		},
		[onChange]
	)

	const handleRemove = useCallback(() => {
		if (onRemove) {
			onRemove()
		} else {
			onChange("")
		}
		setError(null)
		if (fileInputRef.current) {
			fileInputRef.current.value = ""
		}
	}, [onChange, onRemove])

	const openFileDialog = () => {
		if (!disabled && !isUploading) {
			fileInputRef.current?.click()
		}
	}

	const previewUrl = getPreviewUrl(value)

	if (value && !isUploading) {
		return (
			<Card className={cn("relative overflow-hidden", className)}>
				<div className='aspect-video relative'>
					<img
						src={previewUrl || "/placeholder.svg"}
						alt='Uploaded image'
						className='w-full h-full object-cover'
						onError={(e) => {
							;(e.target as HTMLImageElement).src = "/placeholder.svg?height=200&width=300"
						}}
					/>
					<div className='absolute inset-0 bg-black/50 opacity-0 hover:opacity-100 transition-opacity flex items-center justify-center'>
						<Button
							type='button'
							variant='destructive'
							size='sm'
							onClick={handleRemove}
							disabled={disabled}
							className='flex items-center gap-2'>
							<X className='h-4 w-4' />
							Remove
						</Button>
					</div>
					<div className='absolute top-2 right-2'>
						<CheckCircle className='h-5 w-5 text-green-500 bg-white rounded-full' />
					</div>
				</div>
			</Card>
		)
	}

	return (
		<div className={cn("space-y-2", className)}>
			<Card
				className={cn(
					"border-2 border-dashed transition-colors cursor-pointer",
					isDragging && "border-primary bg-primary/5",
					error && "border-destructive",
					disabled && "opacity-50 cursor-not-allowed"
				)}
				onDrop={handleDrop}
				onDragOver={handleDragOver}
				onDragLeave={handleDragLeave}
				onClick={openFileDialog}>
				<div className='p-6 text-center space-y-4'>
					{isUploading ? (
						<div className='space-y-4'>
							<div className='flex items-center justify-center'>
								<Upload className='h-8 w-8 text-primary animate-pulse' />
							</div>
							<div className='space-y-2'>
								<p className='text-sm font-medium'>Uploading image...</p>
								<Progress
									value={uploadProgress}
									className='w-full'
								/>
								<p className='text-xs text-muted-foreground'>{Math.round(uploadProgress)}% complete</p>
							</div>
						</div>
					) : (
						<div className='space-y-4'>
							<div className='flex items-center justify-center'>
								<ImageIcon className='h-8 w-8 text-muted-foreground' />
							</div>
							<div className='space-y-2'>
								<p className='text-sm font-medium'>{label}</p>
								<p className='text-xs text-muted-foreground'>{description}</p>
								<p className='text-xs text-muted-foreground'>Supports: JPEG, PNG, WebP, GIF (max 5MB)</p>
							</div>
							<Button
								type='button'
								variant='outline'
								size='sm'
								disabled={disabled}>
								<Upload className='h-4 w-4 mr-2' />
								Choose File
							</Button>
						</div>
					)}
				</div>
			</Card>

			{error && (
				<div className='flex items-center gap-2 text-sm text-destructive'>
					<AlertCircle className='h-4 w-4' />
					{error}
				</div>
			)}

			<input
				ref={fileInputRef}
				type='file'
				accept={acceptedFormats.join(",")}
				onChange={handleFileSelect}
				className='hidden'
				disabled={disabled || isUploading}
			/>
		</div>
	)
}
